export default __webpack_public_path__ + "static/media/score.a1a407f7.svg";